<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M3,5.998c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S4.654,5.998,3,5.998z M3,1.498c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S3.827,1.498,3,1.498z"/>
	<path d="M3,14.998c-1.654,0-3-1.346-3-3c0-1.654,1.346-3,3-3s3,1.346,3,3C6,13.652,4.654,14.998,3,14.998z M3,10.498
		c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S3.827,10.498,3,10.498z"/>
	<path d="M3,23.998c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S4.654,23.998,3,23.998z M3,19.498c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S3.827,19.498,3,19.498z"/>
	<path d="M8.25,4.498c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h15c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H8.25z"/>
	<path d="M8.25,13.498c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h15c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H8.25z"/>
	<path d="M8.25,22.498c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h15c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H8.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'list-bullets',
    },
    name: {
      type: String,
      required: false,
      default: 'ListBullets',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>